export enum CarouselScrollBehaviour {
  INDIVIDUAL = 'individual',
  GROUP = 'group',
  FREE = 'free',
  FREE_AND_INDIVIDUAL = 'free_and_individual',
}

export enum CarouselArrowPosition {
  INSIDE = 'inside',
  OUTSIDE = 'outside',
  OUTSIDE_BELOW = 'outside-below',
  EDGE = 'edge',
}

export interface CarouselImage {
  src: string;
  alt?: string;
  showGenericFileTypeIcon?: boolean;
}

export enum CarouselDotIndicatorPosition {
  INSIDE = 'inside',
  OUTSIDE = 'outside',
}

export type CarouselAnimationSpeed = 'slow' | 'medium';
